import { GET_LIVECLASS_PACKAGES } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type nl3LiveclassMaster = {
  admissionNumber: string;
  userName: string;
  nlearn3LiveclassPackageId: Array<number>;
};

export const nl3LiveclassMasterInitialValues: nl3LiveclassMaster = {
  admissionNumber: "",
  userName: "",
  nlearn3LiveclassPackageId: []
};

export const nl3LiveclassMasterMandatoryFields = [];

export const nl3LiveclassMasterValidationSchema = Yup.object().shape({
  
});

export const nl3LiveclassMasterProperties = [
  {
    id: "nlearn3LiveclassPackageId",
    type: "multi-select-search",
    label: "Liveclass Package",
    keyValue: { label: "name", value: "id" },
    query: GET_LIVECLASS_PACKAGES,
    gqlKey: "getLiveclassPackages",
    dataKey: "liveclassPackages",
    searchFieldKey: "searchName",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,  
  },
  {
    id: "admissionNumber",
    type: "text",
    label: "Admission Number",
    Placeholder: "Enter Admission Number",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "userName",
    type: "text",
    label: "User Name",
    Placeholder: "Enter User Name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
